<template>
    <transition name="fade">
        <div class="preloader" :style="[loaderType === 'formSubmissionLoader' ? styleForForms : '{}']">  
            <div class="loader" :style="loaderStyles"></div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'preloader',
    computed: {
        isDisneyDemoBot() {
            return this.$store.state.widgetConfig?.brandGPT?.enable || false
        },
        loaderStyles() {
            if(this.isDisneyDemoBot) {
                return {background: `url(${this.$cdn}/images/loader-72w.svg) center no-repeat`}
            }
            return {background: `url(${this.$cdn}/images/loading_anim.svg) center no-repeat`}
        },
        styleForForms() {
            const style = {
                width: this.width + 'px',
                height: this.height + 'px',
                background: 'inherit',
                float: 'right',
                position:'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
            if(this.isPreviousconversationLoading) {
                style['padding'] = '15px 0'
            }
            return style
        }
    },
    props: {
        width: {
            type: Number,
            default: 98
        },
        height: {
            type: Number,
            default: 40
        },
        background: {
            type: String,
            default: '#fff'
        },
        loaderType: {
            type: String,
            default: 'widgetLoader'
        },
        isPreviousconversationLoading: {
            type: Boolean,
            default: false
        }
    },
    
}
</script>
<style lang="scss" scoped>
.preloader{
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 9999;
    .loader{
        width: 50px;
        height: 50px;
        background-size: cover;
        margin: auto;
        animation: spin 1s infinite linear;
    }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
  .loader{
      animation: scaleOut 0.5s;
  }
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
@keyframes scaleOut{
    0%{
        transform: scale(1);
    }
    100%{
        transform: scale(0);
    }
}
@keyframes spin{
    0%{
        transform: rotate(0deg);
    }
    100%{
        transform: rotate(360deg);
    }
}
</style>
